import axios from 'axios';

/**
 * Solr Provider. Works with geomer Solr Wrapper.
 *
 * @class Solr
 */
export class Solr {
  constructor (suggesterUrl, selectionURL, replaceObj) {
    this.settings = {
      url: suggesterUrl,
      selectorUrl: selectionURL,
      replaceSetting: replaceObj,
      params: {
        q: '',
        maxResults: 5
      }
    };
  }

  getParameters (options) {
    if (options.suggesterURL) {
      this.settings.url = options.suggesterURL;
    }
    if (options.selectorURL) {
      this.settings.selectorUrl = options.selectorURL;
    }

    return {
      url: this.settings.url,
      selectorUrl: this.settings.selectorUrl,
      params: {
        query: options.query,
        maxResults: options.limit || this.settings.params.maxResults,
        _: Date.now()
      }
    };
  }

  handleResponse (features) {
    if (!features.result || features.length === 0) {
      return;
    }
    const oldStr = this.settings.replaceSetting.old;
    const newStr = this.settings.replaceSetting.new;
    return features.result.map(function (feature) {
      feature = {
        id: feature.id,
        locationType: feature.locationType,
        address: {
          name: feature.label.replace(oldStr, newStr)
        },
        original: {
          formatted: feature.label.replace(oldStr, newStr)
        }
      };
      return feature;
    });
  }

  async selectFeatures (featID) {
    const request = {
      method: 'GET',
      url: this.settings.selectorUrl + '/' + featID,
      signal: this.abortController?.signal
    };

    const res = await axios(request);
    const data = res.data.result[0];

    const lat = data.coordinate.split(',')[0]
    const lon = data.coordinate.split(',')[1]
    // const buildingId = data.address.buildingId;
    // const streetName = data.address.street;
    // const houseNumber = data.address.houseNumber;

    return { lon, lat };
  }
}
